import { useState } from "react";

const FAQS = [
  ["Where is Studio A located?", "Studio A is a private home-based studio in Bondi Beach, Sydney. The exact address is shared on booking confirmation so the studio stays quiet and private."],
  ["Is parking available?", "Yes — free street parking is generally available around the studio. Full parking details will be included in your booking confirmation."],
  ["Can men book?", "Studio A is a private women's studio. Male clients are considered for facial treatments only, and are accepted by referral or enquiry. Body massage treatments are not available for male clients. New male clients cannot book directly online — please send an enquiry through the Book page."],
  ["What should I wear?", "Something comfortable that's easy to slip out of and back into. For facial treatments you'll rest under warm linen."],
  ["Do you treat sensitive skin?", "Yes — this is most of my work. Rosacea, eczema, reactive skin, hormonal skin. Every appointment is adjusted in real time to what your skin can comfortably receive."],
  ["How long should I allow for my appointment?", "Please allow a few extra minutes before and after. The Studio A Ritual and the Deep Body Ritual are each 90 minutes. There's no waiting room — the time you book is entirely yours."],
  ["Is Studio A really only for women?", "Yes. Studio A is intentionally a women's space — so every woman who walks in can feel completely safe and looked after, without having to think about it."],
  ["I have sensitive skin / rosacea / eczema. Will a facial be safe?", "Yes — and honestly, this is most of my work. Every appointment begins with a real conversation, and I adjust everything in the moment to what your skin can comfortably receive that day."],
  ["What should I expect on my first visit?", "A slow welcome. A short chat about how you've been — not just about your skin. Then a treatment that's shaped from there. You can talk, rest, or fall asleep — all of it is welcome."],
  ["Can I bring my phone?", "Yes, but flight mode is gently encouraged. The room is intentionally quiet, and your hour belongs to you."],
  ["Do you offer skin needling?", "Not yet. Skin needling is being introduced once it's fully approved — I'd rather wait and offer it the way I want to than rush it."],
  ["What about cancellations?", "I ask for 24 hours' notice where possible, but I understand life happens. Just send me a note."],
  ["What do I need to provide as a new client?", "Your full first name and surname (no initials), a working phone number and an email address. It helps me prepare for your visit properly, and reach you if anything changes."],
];

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <div data-testid="faq-page" className="pt-28 lg:pt-44 pb-28">
      <div className="max-w-[1100px] mx-auto px-6 sm:px-10">
        <div className="label-eyebrow">FAQ</div>
        <h1 className="serif mt-7 text-[48px] sm:text-[72px] leading-[1] tracking-tight">Quiet answers.</h1>
        <p className="mt-10 max-w-2xl text-[18px] leading-[1.8] text-[#2E2B27]">
          A few of the questions women ask me before their first visit. If yours isn't here, you're welcome to send me a note.
        </p>
      </div>

      <div className="max-w-[820px] mx-auto px-6 sm:px-10 mt-16">
        <ul>
          {FAQS.map(([q, a], i) => (
            <li key={i} className="border-t border-[#D5CDBF] last:border-b">
              <button
                data-testid={`faq-q-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-baseline justify-between gap-6 py-6 text-left"
              >
                <span className="serif text-[22px] sm:text-[26px] leading-snug">{q}</span>
                <span className="label-eyebrow shrink-0">{open === i ? "Close" : "Open"}</span>
              </button>
              <div
                className="overflow-hidden transition-all duration-500"
                style={{ maxHeight: open === i ? 400 : 0 }}
              >
                <p className="pb-6 pr-12 text-[16px] leading-[1.85] text-[#2E2B27]">{a}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
